import { FilterField, FilterFieldType } from '../filter';

export class TextFilterField extends FilterField<string> {
  readonly type: FilterFieldType = 'text';

  appliedFieldText(): string {
    return this.name + ': ' + this.value;
  }
}
